import createReplacement from '../createReplacement'

import findPlaceholdersForNode from './findPlaceholdersForNode'

const BLOCKED_NODE_SELECTOR = '[data-src]'


export default function findAndReplacePlaceholders({ consentConfig, supportedLocales }) {
  const blockedNodes = Array.from(document.querySelectorAll(BLOCKED_NODE_SELECTOR))

  blockedNodes
    .map(findPlaceholdersForNode)
    .filter(Boolean)
    .forEach(({ hostname, placeholders }) => {
      for ( const placeholder of placeholders ) {
        const replacement = createReplacement({
          consentConfig,
          hostname,
          referenceNode: placeholder,
          supportedLocales,
        })

        placeholder.replaceChildren(replacement)
      }
    })
}
